export const POSTHOG_SOURCES = {
  VAULT_PAGE: 'VAULT_PAGE',
  FAUCET_PAGE: 'FAUCET_PAGE',
  QUANTA_PAGE: 'QUANTA_PAGE',
  LIQUIDATION_PAGE: 'LIQUIDATION_PAGE',
};

export const POSTHOG_EVENTS = {
  // VAULT PAGE
  BASIC_VAULT_REQUEST_SUCCESS: 'BASIC_VAULT_REQUEST_SUCCESS',
  AHA_VAULT_REQUEST_SUCCESS: 'AHA_VAULT_REQUEST_SUCCESS',
  // Create
  CREATE_VAULT_BUTTON_CLICKED: 'CREATE_VAULT_BUTTON_CLICKED',
  CREATE_VAULT_REQUEST_SENT: 'CREATE_VAULT_REQUEST_SENT',
  CREATE_VAULT_REQUEST_SUCCESS: 'CREATE_VAULT_REQUEST_SUCCESS',
  CREATE_VAULT_REQUEST_FAILED: 'CREATE_VAULT_REQUEST_FAILED',
  // Deposit
  DEPOSIT_BUTTON_CLICKED: 'DEPOSIT_BUTTON_CLICKED',
  DEPOSIT_REQUEST_SENT: 'DEPOSIT_REQUEST_SENT',
  DEPOSIT_REQUEST_SUCCESS: 'DEPOSIT_REQUEST_SUCCESS',
  DEPOSIT_REQUEST_FAILED: 'DEPOSIT_REQUEST_FAILED',
  // Withdraw
  WITHDRAW_BUTTON_CLICKED: 'WITHDRAW_BUTTON_CLICKED',
  WITHDRAW_REQUEST_SENT: 'WITHDRAW_REQUEST_SENT',
  WITHDRAW_REQUEST_SUCCESS: 'WITHDRAW_REQUEST_SUCCESS',
  WITHDRAW_REQUEST_FAILED: 'WITHDRAW_REQUEST_FAILED',
  // Repay
  REPAY_BUTTON_CLICKED: 'REPAY_BUTTON_CLICKED',
  REPAY_REQUEST_SENT: 'REPAY_REQUEST_SENT',
  REPAY_REQUEST_SUCCESS: 'REPAY_REQUEST_SUCCESS',
  REPAY_REQUEST_FAILED: 'REPAY_REQUEST_FAILED',
  // Borrow
  BORROW_BUTTON_CLICKED: 'BORROW_BUTTON_CLICKED',
  BORROW_REQUEST_SENT: 'BORROW_REQUEST_SENT',
  BORROW_REQUEST_SUCCESS: 'BORROW_REQUEST_SUCCESS',
  BORROW_REQUEST_FAILED: 'BORROW_REQUEST_FAILED',
  // QUANTA PAGE
  REGISTER_REFERRAL_CODE_SENT: 'REGISTER_REFERRAL_CODE_SENT',
  REGISTER_REFERRAL_CODE_SUCCESS: 'REGISTER_REFERRAL_CODE_SUCCESS',
  REGISTER_REFERRAL_CODE_FAILED: 'REGISTER_REFERRAL_CODE_FAILED',
  // FAUCET PAGE
  CLAIM_TOKENS_BUTTON_CLICKED: 'CLAIM_TOKENS_BUTTON_CLICKED',
  CLAIM_TOKENS_REQUEST_SENT: 'CLAIM_TOKENS_REQUEST_SENT',
  CLAIM_TOKENS_REQUEST_SUCCESS: 'CLAIM_TOKENS_REQUEST_SUCCESS',
  CLAIM_TOKENS_REQUEST_FAILED: 'CLAIM_TOKENS_REQUEST_FAILED',
  CLAIM_TOKENS_REQUEST_REJECTED: 'CLAIM_TOKENS_REQUEST_REJECTED', // too many requests (claimed recently)
  // LIQUIDATION PAGE
  LIQUIDATION_CLAIM_BUTTON_CLICKED: 'LIQUIDATION_CLAIM_BUTTON_CLICKED',
  LIQUIDATION_CLAIM_SENT: 'LIQUIDATION_CLAIM_SENT',
  LIQUIDATION_CLAIM_SUCCESS: 'LIQUIDATION_CLAIM_SUCCESS',
  LIQUIDATION_CLAIM_FAILED: 'LIQUIDATION_CLAIM_FAILED',
  // SWAP PAGE
  SWAP_BUTTON_CLICKED: 'SWAP_BUTTON_CLICKED',
  SWAP_REQUEST_SENT: 'SWAP_REQUEST_SENT',
  SWAP_REQUEST_SUCCESS: 'SWAP_REQUEST_SUCCESS',
  SWAP_REQUEST_FAILED: 'SWAP_REQUEST_FAILED',
  // Ranking API:
  BASKET_ROUNDROBIN_SUCCESS: 'BASKET_ROUNDROBIN_SUCCESS',
  BASKET_ROUNDROBIN_FAILED: 'BASKET_ROUNDROBIN_FAILED',
};
